import { IconWithText } from 'common/icon/icon-with-text.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';

export interface IWind {
  description?: string; // Wind
  forecast?: string; // e.g. Gale force winds can make movement harder and more tiring
  heightMetres?: number;
}

export function ForecastWind({ wind: _wind }: { wind: IWind[] | undefined }): JSX.Element | null {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';

  const wind = _wind ?? [];
  if (wind.length) {
    return (
      <div data-module="forecast-wind">
        {wind.map((w, i) => (
          <IconWithText
            key={w.description ?? i}
            icon="wind"
            classes={`u-mB-sm ${!isLarge ? 'IconWithText--small' : ''}`}
          >
            <h4 className="u-mT-0 u-mB-0">{w.description}</h4>
            <p className="small u-mT-0 u-mB-0">{w.forecast}</p>
          </IconWithText>
        ))}
      </div>
    );
  }
  return null;
}
